import { Size } from '../../../../constants/commonEnums';
import { Card } from '../../../Atoms/Card';
import { RightArrow } from '../../../Icons/rightArrow/RightArrow';
import { getShortDate } from '../../Utils';
import { DEFAULT_THUMBNAIL, EVENT_TYPE } from '../../Utils/constants';
import { IWEBINAR_DATA } from '../../Utils/types';

const WebinarCard = ({
  data,
  eventType,
  onClick,
}: {
  data: IWEBINAR_DATA;
  eventType: string;
  onClick?: () => void;
}): JSX.Element => {
  const isPastEvent = eventType === EVENT_TYPE.PAST ? true : false;
  const buttonText = isPastEvent ? 'Learn now' : 'Register Now';
  const imageLink =
    data.image_link && data.image_link !== 'NA'
      ? data.image_link
      : DEFAULT_THUMBNAIL;

  const handleCardClick = () => {
    if (!isPastEvent && data?.redirection_link?.trim()) {
      window.open(data.redirection_link, '_blank');
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div className="px-2" data-testid="WebinarCard">
      <Card
        border={true}
        padding={Size.SMALL}
        className="w-full max-w-sm m-auto cursor-pointer hover:shadow-md transition transform hover:-translate-y-1 duration-500 border-gray-200 sm:p-3"
        onClick={handleCardClick}
      >
        <div className="relative">
          <img
            src={imageLink}
            alt={eventType}
            width={334}
            height={175}
            className="rounded-lg w-full"
            loading="lazy"
          />
          {data.video_duration && (
            <div className="bg-black text-white rounded-sm text-s-10 py-1 px-2 w-fit absolute bottom-4 right-3">
              {data.video_duration}
            </div>
          )}
        </div>

        <div className="flex justify-between py-2 items-center sm:px-1">
          {data.tag && <Tags data={data.tag} isPastEvent={isPastEvent} />}

          <div
            className={`text-font-200 text-s-14 font-semibold py-2 sm:py-0 sm:text-s-12 hidden ${
              isPastEvent && ' sm:block'
            } ${!data.speaker && 'invisible'}`}
          >
            {data.speaker?.name}, {data.speaker?.designation}
          </div>

          <div className="text-s-14 font-semibold text-font-200 sm:text-s-12">
            {data.airing_at && getShortDate(data.airing_at)} |{' '}
            {data.airing_time}
          </div>
        </div>

        <div className="text-s-20 font-bold pt-2 sm:text-base sm:py-0 sm:px-1 h-16 overflow-hidden second-line-ellipsis sm:h-auto">
          {data.title}
        </div>

        <div
          className={`text-font-200 text-s-14 font-semibold py-2 ${
            isPastEvent && 'sm:hidden'
          } ${!data.speaker && 'invisible'}`}
        >
          {data.speaker?.name}, {data.speaker?.designation}
        </div>

        <div
          className={`text-blue-350 text-s-14 font-semibold gap-2 flex items-center pt-4 sm:text-s-12 sm:pt-0 ${
            isPastEvent && 'sm:hidden'
          } `}
        >
          <span>{buttonText}</span> <RightArrow />
        </div>
      </Card>
    </div>
  );
};

export { WebinarCard };

const Tags = ({
  data,
  isPastEvent,
}: {
  data: Array<{
    id: number;
    title: string;
    created_at: string;
    updated_at: string;
  }>;
  isPastEvent: boolean;
}): JSX.Element => {
  return (
    <div className={`flex gap-2 items-center ${isPastEvent && 'sm:hidden'} `}>
      {data.length ? (
        <>
          {data[0] && (
            <div
              className={`text-[#6D4918] border border-[#FEE8C9] bg-[#FEF3E3] text-s-12 font-semibold py-1 px-2 rounded-sm sm:text-s-10 sm:px-1`}
            >
              {data[0].title}
            </div>
          )}
          {data[1] && (
            <div
              className={`text-[#135B45] border border-[#DBF0E9] bg-[#ECF7F4] text-s-12 font-semibold py-1 px-2 rounded-sm sm:text-s-10 sm:px-1`}
            >
              {data[1].title}
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};
